import { render, staticRenderFns } from "./DeliveryMethod.vue?vue&type=template&id=163ad7b4&lang=html"
import script from "./DeliveryMethod.vue?vue&type=script&lang=js"
export * from "./DeliveryMethod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports